module.exports = function() {
  return new Worker(__webpack_public_path__ + "0614e99bb7209d48bb9b.worker.js");
};